import { brandConfiguration } from "@/brands/config";
export function buildRedirectUrl(currentUrl, redirectUrl) {
    if (!redirectUrl)
        return null;
    const env = process.env.CONFIG_ENV;
    const host = brandConfiguration.urls.staging[env];
    const current = new URL(currentUrl);
    const target = new URL(redirectUrl);
    current.searchParams.forEach((value, key) => {
        if (!target.searchParams.has(key)) {
            target.searchParams.set(key, value);
        }
    });
    const currentPathAndSearch = current.pathname + current.search;
    const targetPathAndSearch = target.pathname + target.search;
    if (host !== target.origin) {
        return target.toString();
    }
    if (currentPathAndSearch === targetPathAndSearch) {
        return null; // no redirect needed
    }
    return target.toString();
}
